/**
 * 2022-01-14
 * 带图片切换标签页组件：SwitchTabWithImage
 */
import { VideoModule } from '@/components/ProductComponents';
import Image from '@/components/UI/Image';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { Tabs } from 'antd';
import { useState } from 'react';
import TextModule from '../TextModule';
import css from './index.module.scss';
const defaultStyle = {
    position: 'top',
    backColor: '#fff',
    height: 'auto',
};

const defaultData = [
    {
        tab: 'EV station charging',
        subTab: 'DELTA Pro is compatible ',
        key: 'k1',
        videoUrl: '"/video/op.mp4"',
        imgUrl: '/img/drone-air.jpg',
        textTitle: 'Power pretty much anything ',
        textDesc:
            'DELTA Pro is compatible with 90% of portable solar panels. And with a 1600W input, you can charge up in as fast as 2.8 hours. Integrate DELTA Pro with your home using the Smart Home Panel and use your rooftop panels to charge up too¹. ',
        textSupliment: '¹While the grid is on-line, supports panels up to 150V, 3000W, requires use of a dedicated accessory (sold separately). ',
        showVideo: false,
    },
    {
        tab: 'Solar charging',
        subTab: 'DELTA Pro is compatible ',
        key: 'k2',
        videoUrl: '"/video/op.mp4"',
        imgUrl: '/img/house_big.jpg',
        textTitle: 'Power pretty much anything ',
        textDesc:
            'DELTA Pro is compatible with 90% of portable solar panels. And with a 1600W input, you can charge up in as fast as 2.8 hours. Integrate DELTA Pro with your home using the Smart Home Panel and use your rooftop panels to charge up too¹. ',
        textSupliment: '¹While the grid is on-line, supports panels up to 150V, 3000W, requires use of a dedicated accessory (sold separately). ',
        showVideo: false,
    },
    {
        tab: 'wind turbine',
        subTab: 'DELTA Pro is compatible ',
        key: 'k3',
        videoUrl: '"/video/op.mp4"',
        imgUrl: '/img/drone-air.jpg',
        textTitle: 'Power pretty much anything ',
        textDesc:
            'DELTA Pro is compatible with 90% of portable solar panels. And with a 1600W input, you can charge up in as fast as 2.8 hours. Integrate DELTA Pro with your home using the Smart Home Panel and use your rooftop panels to charge up too¹. ',
        textSupliment: '¹While the grid is on-line, supports panels up to 150V, 3000W, requires use of a dedicated accessory (sold separately). ',
        showVideo: false,
    },
    {
        tab: 'wall charge',
        subTab: 'DELTA Pro is compatible ',
        key: 'k4',
        videoUrl: '"/video/op.mp4"',
        imgUrl: '/img/house_big.jpg',
        textTitle: 'Power pretty much anything ',
        textDesc:
            'DELTA Pro is compatible with 90% of portable solar panels. And with a 1600W input, you can charge up in as fast as 2.8 hours. Integrate DELTA Pro with your home using the Smart Home Panel and use your rooftop panels to charge up too¹. ',
        textSupliment: '¹While the grid is on-line, supports panels up to 150V, 3000W, requires use of a dedicated accessory (sold separately). ',
        showVideo: false,
    },
];

const textTitleDefaultStyle = {
    margin: '0 auto',
    type: 'ls',
    textAlign: 'center',
};
const textDescDefaultStyle = {
    fontFamily: 'var(--font-family-SemiBold)',
    margin: '40px auto 0 auto',
    lineHeight: '30px',
    type: 'sl',
    textAlign: 'center',
};
const textSuplimentDefaultStyle = {
    margin: '32px auto 0 auto',
    lineHeight: '25px',
    type: 'ss',
    textAlign: 'center',
};

/**
 *
 * @param cssStyle{
 *   position: 图片/视频位置 string,  // top(default), bottom, left, right
 *   backColor: 背景色 string,
 *   height: 高度 string,
 * }
 *
 * @param data[
 * {
 * tab： tab文本,
 * subTab: tab副文本,
 * key：key值,
 * videoUrl: 视频地址,
 * imgUrl：图片地址,
 * textTitle: 主标题文本,
 * textDesc: 说明文字文本,
 * textSupliment：补充文字文本,
 * showVideo：是否显示视频(视频和图片只展示一种)
 * }
 * ]
 */

export default function SwitchTabModule({ cssStyle, data = defaultData }: any) {
    const styles = { ...defaultStyle, ...cssStyle };
    const { position, backColor, height, wordSpacing, letterSpacing } = styles;
    const { TabPane } = Tabs;
    const [item, setItem] = useState(data[0]);
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('product');
    const { locale } = useRouter();
    const { EFPic } = createEFPic(styles.webpUrl);

    const changeTab = (key: any) => setItem(data.filter((list: any) => list.key === key)[0]);

    return (
        <div
            className={`${css.switchTabWithImage} switchTabWithImage font-family-semibold`}
            style={{
                background: backColor,
                height: height,
                wordSpacing: wordSpacing,
                letterSpacing: letterSpacing,
            }}
        >
            {/* 1. 顶部视频/图片 position: top */}
            {position === 'top' && (
                <div className="wrapper wrapperTop">
                    {item.showVideo ? (
                        <div className="videoBox">
                            <VideoModule
                                config={{
                                    height: '630px',
                                    src: item.videoUrl,
                                    autoPlay: true,
                                    hideControl: true,
                                }}
                            />
                        </div>
                    ) : (
                        <div className="imgBox" style={{ width: '1280px', height: '630px', position: 'relative' }}>
                            {Array.isArray(item.imgUrl) ? (
                                <EFPic name={item.imgUrl} alt={t(item.tab)} />
                            ) : (
                                <Image src={item.imgUrl} layout="fill" alt={t(item.tab)} />
                            )}
                        </div>
                    )}
                    <div className={backColor === '#fff' ? 'container whiteTab' : 'container blackTab'} style={{ marginTop: '80px' }}>
                        <Tabs className="tabs" defaultActiveKey={data[0].key} centered onChange={changeTab}>
                            {data.map((list: any, k: number) => (
                                <TabPane tab={list.tab} key={list.key} className={k === data.length ? 'lastItem' : ''}>
                                    <div className="switchTextModule1">
                                        <TextModule
                                            data={{ text: list.textTitle }}
                                            cssStyle={{
                                                ...textTitleDefaultStyle,
                                                ...{
                                                    backColor: backColor,
                                                    color: backColor === '#fff' ? '#03060b' : '#fff',
                                                    width: styles.width || '924px',
                                                    fontWeight: locale === 'cn' ? 600 : 700,
                                                },
                                            }}
                                        />
                                    </div>
                                    <div className="switchTextModule2">
                                        <TextModule
                                            data={{ text: list.textDesc }}
                                            cssStyle={{
                                                ...textDescDefaultStyle,
                                                ...{
                                                    backColor: backColor,
                                                    color: backColor === '#fff' ? '#03060b' : '#fff',
                                                    width: styles.width || '924px',
                                                },
                                            }}
                                        />
                                    </div>
                                    <TextModule
                                        data={{ text: list.textSupliment }}
                                        cssStyle={{
                                            ...textSuplimentDefaultStyle,
                                            ...{
                                                backColor: backColor,
                                                width: styles.width || '924px',
                                            },
                                        }}
                                    />
                                </TabPane>
                            ))}
                        </Tabs>
                    </div>
                </div>
            )}
            {/* 2. 底部视频/图片 position: bottom */}
            {position === 'bottom' && (
                <div className="wrapper wrapperBottom">
                    <div className={backColor === '#fff' ? 'container whiteTab' : 'container blackTab'} style={{ marginBottom: '80px' }}>
                        <Tabs className="tabs" defaultActiveKey={data[0].key} centered onChange={changeTab}>
                            {data.map((list: any) => (
                                <TabPane tab={list.tab} key={list.key}>
                                    <TextModule
                                        data={{ text: list.textTitle }}
                                        cssStyle={{
                                            ...textTitleDefaultStyle,
                                            ...{
                                                backColor: backColor,
                                                color: backColor === '#fff' ? '#03060b' : '#fff',
                                                fontWeight: locale === 'cn' ? 600 : 700,
                                            },
                                        }}
                                    />
                                    <TextModule
                                        data={{ text: list.textDesc }}
                                        cssStyle={{
                                            ...textDescDefaultStyle,
                                            ...{
                                                backColor: backColor,
                                                color: backColor === '#fff' ? '#03060b' : '#fff',
                                            },
                                        }}
                                    />
                                    <TextModule
                                        data={{ text: list.textSupliment }}
                                        cssStyle={{
                                            ...textSuplimentDefaultStyle,
                                            ...{ backColor: backColor },
                                        }}
                                    />
                                </TabPane>
                            ))}
                        </Tabs>
                    </div>
                    {item.showVideo ? (
                        <div className="videoBox">
                            <VideoModule
                                config={{
                                    height: '630px',
                                    src: item.videoUrl,
                                    autoPlay: true,
                                    hideControl: true,
                                }}
                            />
                        </div>
                    ) : (
                        <div className="imgBox" style={{ width: '1280px', height: '630px' }}>
                            {Array.isArray(item.imgUrl) ? (
                                <EFPic name={item.imgUrl} alt={t(item.tab)} />
                            ) : (
                                <Image src={item.imgUrl} layout="fill" alt={t(item.tab)} />
                            )}
                        </div>
                    )}
                </div>
            )}
            {/* 3. 右侧视频/图片 position: bottom */}
            {position == 'right' && (
                <div className="wrapper wrapperRight">
                    <div className={backColor === '#fff' ? 'container whiteTab' : 'container blackTab'}>
                        <Tabs tabPosition="left" className="tabs leftTabs" onChange={changeTab}>
                            {data.map((list: any) => (
                                <TabPane
                                    key={list.key}
                                    tab={
                                        <span>
                                            {list.tab}
                                            <b
                                                className="subTab"
                                                style={{
                                                    color: backColor === '#fff' ? '#03060b' : '#fff',
                                                }}
                                            >
                                                {list.subTab}
                                            </b>
                                        </span>
                                    }
                                >
                                    {item.showVideo ? (
                                        <div className="videoBox">
                                            {' '}
                                            <VideoModule
                                                config={{
                                                    height: '450px',
                                                    src: item.videoUrl,
                                                    autoPlay: true,
                                                    hideControl: true,
                                                }}
                                            />{' '}
                                        </div>
                                    ) : (
                                        <div className="imgBox" style={{ width: '720px', height: '450px' }}>
                                            {Array.isArray(item.imgUrl) ? (
                                                <EFPic name={item.imgUrl} alt={t(item.tab)} />
                                            ) : (
                                                <Image src={item.imgUrl} layout="fill" alt={t(item.tab)} />
                                            )}
                                        </div>
                                    )}
                                </TabPane>
                            ))}
                        </Tabs>
                    </div>
                </div>
            )}
            {/* 4. 左侧视频/图片 position: bottom */}
            {position == 'left' && (
                <div className="wrapper wrapperLeft">
                    <div className={backColor === '#fff' ? 'container whiteTab' : 'container blackTab'}>
                        <Tabs tabPosition="right" className="tabs rightTabs" onChange={changeTab}>
                            {data.map((list: any) => (
                                <TabPane
                                    key={list.key}
                                    tab={
                                        <span>
                                            {list.tab}
                                            <b
                                                className="subTab"
                                                style={{
                                                    color: backColor === '#fff' ? '#03060b' : '#fff',
                                                }}
                                            >
                                                {list.subTab}
                                            </b>
                                        </span>
                                    }
                                >
                                    {item.showVideo ? (
                                        <div className="videoBox">
                                            {' '}
                                            <VideoModule
                                                config={{
                                                    height: '450px',
                                                    src: item.videoUrl,
                                                    autoPlay: true,
                                                    hideControl: true,
                                                }}
                                            />{' '}
                                        </div>
                                    ) : (
                                        <div className="imgBox" style={{ width: '720px', height: '450px' }}>
                                            {Array.isArray(item.imgUrl) ? (
                                                <EFPic name={item.imgUrl} alt={t(item.tab)} />
                                            ) : (
                                                <Image src={item.imgUrl} layout="fill" alt={t(item.tab)} />
                                            )}
                                        </div>
                                    )}
                                </TabPane>
                            ))}
                        </Tabs>
                    </div>
                </div>
            )}
        </div>
    );
}
